import { Component, ElementRef, ViewChild } from '@angular/core';
import { ReceiptCancellationDialogComponent } from '../receipt-cancellation-dialog/receipt-cancellation-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { ReceiptCancellationService } from '../receipt-cancellation.service';
import { MatDialog } from '@angular/material/dialog';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';

@Component({
  selector: 'app-receipt-cancellation',
  templateUrl: './receipt-cancellation.component.html',
  styleUrls: ['./receipt-cancellation.component.scss']
})
export class ReceiptCancellationComponent {
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
 
  displayedColumns2: string[] = [
     'campusName', 'userName', 
    'daysheetDate','admNo', 'prePrintedReceiptNo', 'payMode','amount', 'view'
  ];
  totalcctvdata: any;
  // sort: any;
  // paginator: any;
  dataAvailable = true;
  selectedRow: any;
  recepitcancalltion: any;
  dialogRef: any;
  constructor(private el: ElementRef, private campuscctvserviceservice:ReceiptCancellationService , private dailog: MatDialog, public dialog1: NgDialogAnimationService,private spinner: NgxSpinnerService,private toast:ToastmessageService ) { }
  ngOnInit(): void {
//  this.loadData()
this.loadtest()
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.recepitcancalltion.filter = filterValue.trim().toLowerCase();
    console.log('filterValue', filterValue);
  }
 
  loadtest(){
    this.spinner.show()
    this.campuscctvserviceservice.recepit().subscribe({
      next:(data:any)=>{
        if(data&&data.length > 0){
          this.recepitcancalltion= new MatTableDataSource(data);
          this.recepitcancalltion.sort= this.sort;
          this.recepitcancalltion.paginator= this.paginator;
          this.dataAvailable = true; 
        }else{
          this.dataAvailable = false;
        }
        this.spinner.hide();
      },error: (error: any) => {
        this.spinner.hide();
        // this.errorService.errorDisplay(Number(error.status), "Error", "");
        if (error.status === 422) {
          this.toast.showWarning("Student will be tranfer");
        } 
        this.dataAvailable = false; 
      }
    })
  }
  alldata(data: any) {
    this.selectedRow = data;
     this.dialogRef = this.dialog1.open(ReceiptCancellationDialogComponent, {
      data: data,
      // disableClose: true,
      direction: 'ltr',
      height: '100%',
      width: '45%',
      position: { right: '0px', top: '0px' },
      animation: { to: "left" },

    });
    this.dialogRef.afterClosed().subscribe((value:any) => {
      if(value=="DATA"){
        this.spinner.show()
     this.loadtest()
     this.spinner.hide()
      }
   })
  }
  isSelected(row: any): boolean {
    return this.selectedRow === row;
  }
 
}
